import { gsap } from 'gsap';

const block = document.querySelector('.block-interactive-graphic');
const interactiveGraphic = document.getElementById(
	'block-interactive-graphic__graphic'
);
const outerWheel = document.getElementById(
	'block-interactive-graphic__graphic-outer-wheel'
);
const outerWheelCogs = interactiveGraphic.querySelectorAll('.cog');
const centerWheel = document.getElementById(
	'block-interactive-graphic__graphic-center-wheel'
);
const centerWheelCog = document.getElementById(
	'block-interactive-graphic__graphic-center-wheel-cog'
);
const navArrows = block.querySelectorAll(
	'.block-interactive-graphic__mobile-nav .arrows .arrow'
);
const navDots = block.querySelectorAll(
	'.block-interactive-graphic__mobile-nav .dots .dot'
);
const contentBlocks = block.querySelectorAll(
	'.block-interactive-graphic__content-block'
);

let canTriggerAnimation = true;
let isdefaultState = true;
let cumulativeRotation = 0;
let currentIndex = 0;
const anglePerCog = 360 / -outerWheelCogs.length;

// Animate in graphic on load
window.addEventListener('load', () => {
	const tl = gsap.timeline();

	// Set default values for wheels
	gsap.set([centerWheel, outerWheel], {
		transformOrigin: 'center center',
		scale: 0,
	});

	// Set content blocks hidden by default
	contentBlocks.forEach((contentBlock) => {
		gsap.set(contentBlock, {
			opacity: 0,
			display: 'none',
		});
	});

	block.classList.add('active');
	block.classList.add('default-state');

	// Scale in center wheel
	tl.to(centerWheel, {
		scale: 1,
		duration: 0.75,
		transformOrigin: '50% 50%',
		ease: 'power2.inOut',
	});

	// Scale in outer wheel
	tl.to(
		outerWheel,
		{
			scale: 1,
			duration: 0.75,
			transformOrigin: '50% 50%',
			ease: 'power2.inOut',
		},
		'>-0.4'
	);

	// Fade in first content block
	tl.to(
		contentBlocks[0],
		{
			opacity: 1,
			duration: 0.5,
			ease: 'expo.inOut',
			display: 'block',
		},
		'>-0.2'
	);
});

// Cog click handlers
outerWheelCogs.forEach((cog, i) => {
	cog.addEventListener('click', () => {
		const index = i === currentIndex && !isdefaultState ? 0 : i;
		animateGraphic(index, i === currentIndex && !isdefaultState);
	});
});

// Cog enter key handler
outerWheelCogs.forEach((cog, index) => {
	cog.addEventListener('keydown', (e) => {
		if (e.keyCode === 13) {
			animateGraphic(index);
		}
	});
});

// Center wheel click handler
centerWheel.addEventListener('click', () => {
	animateGraphic(0, true);
});

// Mobile nav arrows click handler
if (navArrows.length) {
	navArrows.forEach((arrow) => {
		arrow.addEventListener('click', (e) => {
			const direction = e.target.dataset.direction;
			let nextIndex;
			if (direction === 'next') {
				nextIndex =
					currentIndex === 0
						? outerWheelCogs.length - 1
						: currentIndex - 1;
			} else {
				nextIndex =
					currentIndex === outerWheelCogs.length - 1
						? 0
						: currentIndex + 1;
			}
			animateGraphic(nextIndex);
		});
	});
}

// Mobile nav dots click handler
if (navDots.length) {
	navDots.forEach((dot) => {
		dot.addEventListener('click', () => {
			const dataIndex = parseInt(dot.dataset.index);
			const index =
				dataIndex === currentIndex && !isdefaultState ? 0 : dataIndex;
			animateGraphic(
				index,
				dataIndex === currentIndex && !isdefaultState
			);
		});
	});
}

function calculateDistance(index) {
	if (currentIndex === index) {
		return 0;
	}
	if (index > currentIndex) {
		return outerWheelCogs.length - (index - currentIndex);
	}
	return currentIndex - index;
}

const animateGraphic = (index, goToDefaultState = false) => {
	if (!canTriggerAnimation) return;

	canTriggerAnimation = false;

	// Clicking the active cog will reset back to the default state.
	isdefaultState =
		(index === currentIndex && !isdefaultState) || goToDefaultState;

	const tl = gsap.timeline();
	const totalCogs = 6;
	const indexDistance = calculateDistance(index, totalCogs);
	const rotationAmount = -anglePerCog * indexDistance + cumulativeRotation;
	const duration = 1;

	if (isdefaultState) {
		// Add default state class to block
		block.classList.add('default-state');

		// Fade in all cogs
		outerWheelCogs.forEach((cog) => cog.classList.remove('inactive'));

		// Fade out current content
		tl.to(
			contentBlocks[currentIndex + 1],
			{
				opacity: 0,
				duration: 0.5,
				ease: 'expo.inOut',
				display: 'none',
			},
			0
		);

		// Fade in default content block
		tl.to(
			contentBlocks[0],
			{
				opacity: 1,
				duration: 0.5,
				ease: 'expo.inOut',
				display: 'block',
			},
			'>-.001'
		);

		// Rotate outer wheel
		tl.to(
			[outerWheel, centerWheelCog],
			{
				rotation: rotationAmount,
				duration,
				transformOrigin: 'center center',
				ease: 'expo.inOut',
			},
			0
		);

		// Shrink outer wheel
		if (goToDefaultState && currentIndex !== 0) {
			tl.to(
				outerWheel,
				{
					scale: 0.9,
					duration: duration / 2,
					transformOrigin: 'center center',
					ease: 'expo.inOut',
				},
				0
			);
		}

		// Grow outer wheel
		tl.to(
			outerWheel,
			{
				scale: 1,
				duration: duration / 5,
				transformOrigin: 'center center',
				ease: 'expo.out',
			},
			'>'
		);

		// Counter rotate cog icon/text
		outerWheelCogs.forEach((cog) => {
			const iconGroup = cog.querySelector('g');
			tl.to(
				iconGroup,
				{
					rotation: -rotationAmount,
					duration,
					transformOrigin: 'center center',
					ease: 'expo.inOut',
					delay: 0,
					onComplete: () => {
						canTriggerAnimation = true;
					},
				},
				0
			);
		});

		// Update mobile nav dots
		navDots[outerWheelCogs.length - 1 - currentIndex].classList.remove(
			'active'
		);
	} else {
		// Remove default state class to block
		block.classList.remove('default-state');

		// Fade out all other cogs
		outerWheelCogs.forEach((cog, i) => {
			if (i !== index) {
				cog.classList.add('inactive');
			} else {
				cog.classList.remove('inactive');
			}
		});

		// Rotate outer wheel
		tl.to(
			[outerWheel, centerWheelCog],
			{
				rotation: rotationAmount,
				duration,
				transformOrigin: 'center center',
				ease: 'expo.inOut',
			},
			0
		);

		if (index !== currentIndex) {
			// Shrink outer wheel
			tl.to(
				outerWheel,
				{
					scale: 0.9,
					duration: duration / 2,
					transformOrigin: 'center center',
					ease: 'expo.inOut',
				},
				0
			);
		}

		// Grow outer wheel
		tl.to(
			outerWheel,
			{
				scale: 1,
				duration: duration / 5,
				transformOrigin: 'center center',
				ease: 'expo.out',
			},
			'>'
		);

		// Fade out current content block and default content block
		tl.to(
			[contentBlocks[currentIndex + 1], contentBlocks[0]],
			{
				opacity: 0,
				duration: 0.5,
				ease: 'expo.inOut',
				display: 'none',
			},
			0
		);

		// Fade in next content block.
		tl.to(
			contentBlocks[index + 1],
			{
				opacity: 1,
				duration: 0.5,
				ease: 'expo.inOut',
				display: 'block',
			},
			'>-.001' // This helps to make sure there is no gap between the previous block becoming display: none and this content block becoming display: block (causes content after this block to jump very briefly).
		);

		// Counter rotate cog icon/text
		outerWheelCogs.forEach((cog) => {
			const iconGroup = cog.querySelector('g');
			tl.to(
				iconGroup,
				{
					rotation: -rotationAmount,
					duration,
					transformOrigin: 'center center',
					ease: 'expo.inOut',
					delay: 0,
					onComplete: () => {
						canTriggerAnimation = true;
					},
				},
				0
			);
		});

		// Update mobile nav dots
		navDots.forEach((dot) => {
			const dataIndex = parseInt(dot.dataset.index);
			if (dataIndex === index) {
				dot.classList.add('active');
			} else {
				dot.classList.remove('active');
			}
		});
	}

	currentIndex = index;
	cumulativeRotation += indexDistance * -anglePerCog;
};
